/**
 * @generated SignedSource<<a41af209eddd31d005a4b1e84708e907>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobEventCreated_job$data = {
  readonly agentQueryRules: ReadonlyArray<string> | null;
  readonly cluster: {
    readonly name: string;
    readonly organization: {
      readonly slug: string;
    } | null;
    readonly uuid: string;
  } | null;
  readonly clusterQueue: {
    readonly cluster: {
      readonly name: string;
      readonly organization: {
        readonly slug: string;
      } | null;
      readonly uuid: string;
    } | null;
    readonly dispatchPaused: boolean;
    readonly dispatchPausedAt: any | null;
    readonly dispatchPausedBy: {
      readonly name: string;
    } | null;
    readonly dispatchPausedNote: string | null;
    readonly key: string;
    readonly uuid: string;
  } | null;
  readonly concurrency: {
    readonly group: string;
    readonly limit: number;
  } | null;
  readonly createdAt: any | null;
  readonly matrix: any | null;
  readonly priority: {
    readonly number: number | null;
  };
  readonly step: {
    readonly conditional: string | null;
    readonly dependencies: {
      readonly count: number;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly key: string | null;
          readonly uuid: string;
        } | null;
      } | null> | null;
    } | null;
    readonly key: string | null;
    readonly uuid: string;
  } | null;
  readonly uuid: string;
  readonly " $fragmentType": "JobEventCreated_job";
};
export type JobEventCreated_job$key = {
  readonly " $data"?: JobEventCreated_job$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobEventCreated_job">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Cluster",
  "kind": "LinkedField",
  "name": "cluster",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventCreated_job",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "number",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agentQueryRules",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ClusterQueue",
      "kind": "LinkedField",
      "name": "clusterQueue",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dispatchPaused",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dispatchPausedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "dispatchPausedBy",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dispatchPausedNote",
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobConcurrency",
      "kind": "LinkedField",
      "name": "concurrency",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "group",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "limit",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "matrix",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StepCommand",
      "kind": "LinkedField",
      "name": "step",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "conditional",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 30
            }
          ],
          "concreteType": "DependencyConnection",
          "kind": "LinkedField",
          "name": "dependencies",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "DependencyEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Dependency",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "dependencies(first:30)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "JobTypeCommand",
  "abstractKey": null
};
})();

(node as any).hash = "0f2106d82bc4510ab3d10a2046af326f";

export default node;
